import React, { memo, useEffect, useRef, useCallback, useState } from 'react';
import LottieView from 'lottie-react-native';
import { AnimationPlayerProps } from './AnimationPlayer.types';
import { normalizeDimension } from './AnimationPlayer.utils';
import Box from '../Box/Box';

const AnimationPlayer = ({
  sizeX,
  sizeY,
  autoPlay = true,
  source,
  onComplete,
  ...rest
}: AnimationPlayerProps) => {
  const [animation, setAnimation] = useState<string>();
  const animationRef = useRef<LottieView>(null);

  const loadSource = useCallback(async () => {
    const result = await source();

    setAnimation(result.default as unknown as string);
  }, [source]);

  useEffect(() => {
    loadSource();
  }, [loadSource]);

  return (
    <Box
      centerContent
      overflow="hidden"
      width={normalizeDimension(sizeX)}
      height={normalizeDimension(sizeY)}
    >
      {animation ? (
        <LottieView
          ref={animationRef}
          autoPlay={autoPlay}
          style={{ width: '100%', height: '100%' }}
          onAnimationFinish={(isCancelled) => {
            if (!rest.loop) {
              onComplete?.(isCancelled);
            }
          }}
          source={animation}
          {...rest}
        />
      ) : null}
    </Box>
  );
};

export default memo(AnimationPlayer);
